// Components==============
import React from 'react';
import Footer from './components/Footer';
import Nav from './components/Nav';
import './index.module.scss';
// =========================

export default function Layout({ children }) {
    return (
        <div styleName="layout">
            <Nav />
            <div styleName="content" id="scroll-container">
                {children}
                <Footer />
            </div>
        </div>
    );
}
